import React from 'react';
import { c as classnames } from '../../../index-2586sEvh.js';
export { I as Input } from '../../../Input-quQLghm0.js';
import '../../../_commonjsHelpers-jjO7Zipk.js';
import 'lodash/get';
import 'next-i18next';

const InputGroup = ({ children, align = 'stretch', vertical = 'max-768' }) => {
    const verticalClass = vertical === 'always' ? 'vertical' : `vertical-${vertical}`;
    return (React.createElement("div", { className: classnames(`input-group align-${align} ${verticalClass}`) }, children));
};

export { InputGroup };
//# sourceMappingURL=index.js.map
